import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import PhotoLibraryRoundedIcon from '@mui/icons-material/PhotoLibraryRounded';
import PermMediaRoundedIcon from '@mui/icons-material/PermMediaRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import CardMembershipRoundedIcon from '@mui/icons-material/CardMembershipRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import type { SvgIconComponent } from '@mui/icons-material';

export interface AdminNavItem {
  to: string;
  label: string;
  icon: SvgIconComponent;
}

export const adminNavItems: AdminNavItem[] = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: DashboardRoundedIcon },
  { to: '/admin/notifications', label: 'Notifications', icon: NotificationsRoundedIcon },
  { to: '/admin/bookings', label: 'Bookings', icon: AssignmentRoundedIcon },
  { to: '/admin/schedule', label: 'Slot calendar', icon: CalendarMonthRoundedIcon },
  { to: '/admin/bookings/add', label: 'Add booking', icon: PostAddRoundedIcon },
  { to: '/admin/payments', label: 'Payments', icon: PaymentsRoundedIcon },
  { to: '/admin/reports', label: 'Reports', icon: AnalyticsRoundedIcon },
  { to: '/admin/court-settings', label: 'Court settings', icon: SettingsRoundedIcon },
  { to: '/admin/membership-settings', label: 'Membership', icon: CardMembershipRoundedIcon },
  { to: '/admin/users', label: 'Users', icon: PeopleRoundedIcon },
  { to: '/admin/venue-showcase', label: 'Courts & venues', icon: PhotoLibraryRoundedIcon },
  { to: '/admin/gallery', label: 'Gallery', icon: PermMediaRoundedIcon },
];
